import { Component } from '@angular/core';
import { App, NavController, NavParams, Events, PopoverController, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { trigger, transition, useAnimation, state, style } from '@angular/animations';
import { tada } from 'ng-animate';
import { PedidosPage } from '../pedidos/pedidos';
import { ClientesPage } from '../clientes/clientes';
import { FacturasPage } from '../facturas/facturas';
import { PedidoPage} from '../pedido/pedido';
import { HttpProvider } from '../../providers/http/http';
import { MonedaPage } from '../moneda/moneda';
import { HomePage } from '../home/home';
import * as moment from 'moment';
import { File } from '@ionic-native/file';

/**
 * Generated class for the DashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
  animations:[
    trigger('car',[
      state('open',style({
        'height': '5vh',
        'border-radius': '10px',
        'background-color': 'dodgerblue',
        'width': '5vh',
        'display': 'flex',
        'justify-content': 'center',
        'align-items': 'center' 
      })),
      state('close',style({
        'height': '5vh',
        'border-radius': '10px',
        'background-color': 'dodgerblue',
        'width': '5vh',
        'display': 'flex',
        'justify-content': 'center',
        'align-items': 'center'
      })),
      transition('open=>close',useAnimation(tada,{
        params:{
          timing:2
        }
      })),
      transition('close=>open',useAnimation(tada,{
        params:{
          timing:2
        }
      }))
    ])
  ]
})
export class DashboardPage {
  cant : any = 0
  btnPed: any = "C"
  btnCli: any = "A"
  pedido : any = {}
  fechaA: any
  nombre: any
  tasa: any = 0
  errs: any = 0
  co_ven: any
  pedidos: any = []
  pedidos_cre: any
  pedidos_anu: any
  pedidos_pro: any
  solventes: any = 0
  cuentas: any = 0
  morosos: any = 0
  activacion: any = 0
  noactivacion: any = 0
  facturas: any = null
  monto:any = null
  loadFact: any = false
  proyeccion: any
  loadPed: any = false
  loadCli: any = false
  loadAct: any = false
  super: any = null
  moneda: any = 'USD'
  police: any = false
  cambio: any = null
  conexion: any
  loadModal: any
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public app: App,
    public toastCtrl: ToastController,
    public events : Events,
    public file:File,
    public loadingCtrl: LoadingController,
    public http : HttpProvider,
    public alertCtrl: AlertController,
    public popCtrl: PopoverController
    ) {
      this.updateMoneda()
      this.nombre = window.localStorage.getItem('nombre').split(' ')[0]
      if(window.localStorage.getItem('super')){
        this.super = true
      }else{
        this.co_ven = window.localStorage.getItem('co_ven')
      }
      this.update()
      events.subscribe('pedido:update',()=>{
        this.update()
      })
      events.subscribe('moneda:update', ()=>{
        this.updateMoneda()
      })
      this.initialize()
  }

  ActivarLoadingOffline() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Respaldando información <br/>Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoadingOffline() {
    this.loadModal.dismiss();
  }

  async obtenerInfo(url, stitem) {
    return await new Promise(async resolve => {
      this.http.get(url).subscribe(
        async (res:any)=>{
          if (res && res.length > 0) window.localStorage.setItem(stitem, JSON.stringify(res));
          resolve(true)
        },
        async error=>{
          console.log(error)
          this.errs++
          resolve(false)
        }
      )
    })
  }

  async writeJSON(filename, object) {
    let save = await this.file.writeFile(this.file.dataDirectory, filename, JSON.stringify(object), {replace:true})
    window.localStorage.setItem('productosferco', 'true');
    return save
  }

  async obtenerProd(url) {
    return await new Promise(async resolve => {
      this.http.get(url).subscribe(
        async (res:any)=>{
          res.map(el=>{
            el.cant = 0
            el.precio = {}
          })
          for (let i = 0; i < res.length; i++) {
            for (let j = 0; j < res[i].precios.length; j++) {
              let el2 = res[i].precios[j];
              el2.monto = parseFloat(parseFloat(el2.monto).toFixed(2))
            }
            res[i].stock = parseFloat(res[i].stock.toFixed(2))
            res[i].stockP = res[i].stock
            res[i].unidad = res[i].unidades[0]
            res[i].equivalente = res[i].equivalencia[0]
            res[i].precio = res[i].precios[0]
          }
          if (res && res.length > 0) this.writeJSON('avaflexproductos.json', res)
          resolve(true)
        },
        async error=>{
          console.log(error)
          this.errs++
          resolve(false)
        }
      )
    })
  }

  async cambiarConexion() {
    if (this.conexion === "1") {
      await this.ActivarLoadingOffline()
      this.errs = 0
      const urlCli = this.super ? `cliente/sup?vendedores=${window.localStorage.getItem('vendedores')}` : `cliente/ven/${this.co_ven}`
      let cli = await this.obtenerInfo(urlCli, 'clientes')
      if (cli) window.localStorage.setItem('horaClientes', moment().format('DD-MM-YYYY H:mm A'));
      let prod = await this.obtenerProd('productosCom')
      if (prod) window.localStorage.setItem('horaProductos', moment().format('DD-MM-YYYY H:mm A'));
      let urlPed = this.super ? `pedidosCom/sup?fecha=si&vendedores=${window.localStorage.getItem('vendedores')}` : `pedidosCom/vend/${this.co_ven.replace(/ /g,'')}?fecha=si`
      let ped = await this.obtenerInfo(urlPed, 'pedidosN')
      if (ped) window.localStorage.setItem('horaPedidos', moment().format('DD-MM-YYYY H:mm A'));
      await this.obtenerInfo('condicion', 'condiciones')
      if (this.super) {
        let urlVend = `vendedor/sup?vendedores=${window.localStorage.getItem('vendedores')}`
        let vend = await this.obtenerInfo(urlVend, 'vendedoresM')
        if (vend) window.localStorage.setItem('horaVendedor', moment().format('DD-MM-YYYY H:mm A'));
      }
      await this.DesactivarLoadingOffline()
      if (this.errs == 0) {
        this.conexion = window.localStorage.setItem('network', '0')
        this.conexion = '0'
        this.alertCtrl.create({
          title: '¡Felicidades!',
          subTitle:'Su conexión a la red a sido desconectada.',
          buttons:[
            {
              text:'Aceptar',
              cssClass:'btnAceptar',
              handler:()=>{
              }
            }
          ]
        }).present()
      } else {
        this.alertCtrl.create({
          title: '¡Atención!',
          subTitle:'Por problemas de conexión no se pudo respaldar toda la información, vuelva a intentarlo.',
          buttons:[
            {
              text:'Aceptar',
              cssClass:'btnAceptar',
              handler:()=>{
              }
            }
          ]
        }).present()
      }
    } else {
      this.conexion = window.localStorage.setItem('network', '1')
      this.conexion = '1'
      this.initialize()
      this.alertCtrl.create({
        title: '¡Felicidades!',
        subTitle:'Su conexión a la red a sido restablecida.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.cambio = parseFloat(window.localStorage.cambio)
      this.moneda = window.localStorage.moneda
    }
  }

  showMonedas(){
    const pop = this.popCtrl.create(MonedaPage)
    pop.present()
  }

  ionViewDidEnter() {
    this.conexion = window.localStorage.getItem('network')
    this.update()
    this.http.get('condicion').subscribe(
      (res:any)=>{
        if (res && res.length > 0) {
          window.localStorage.setItem('condiciones', JSON.stringify(res))
        }
      }
    )
    this.http.get('almacen/activa').subscribe(
      (res:any)=>{
        if (res && res.length > 0) {
          window.localStorage.setItem('almacenes', JSON.stringify(res))
        }
      }
    )
  }
  
  doRefresh(refresher) {
    setTimeout(() => {
      this.initialize()
      refresher.complete();
    }, 2000);
  }

  contar(){
    // let cant = 0
    // this.pedido.articulos.forEach(el=>{
    //   cant += parseFloat(el.cant)
    // })
    this.cant = (this.pedido && this.pedido.articulos && this.pedido.articulos.length > 0) ? this.pedido.articulos.length : 0
  }

  update(){
    if(window.localStorage.getItem('pedido')){
      this.pedido = JSON.parse(window.localStorage.getItem('pedido'))
      if(!this.pedido.articulos || !this.pedido.articulos.length){
        this.pedido.articulos = []
      }
      this.contar()
    }
  }

  transform(value) {
    if(value){
      let val = value
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  irPedido(){
    this.navCtrl.push(PedidoPage)
  }

  calcularFaltante(item) {
    if (parseFloat(item.totalPedido) >= parseFloat(item.proyeccion)) {
      return 0
    } else {
      return (parseFloat(item.proyeccion) - parseFloat(item.totalPedido)).toFixed(2)
    }
  }

  calcularFaltanteMarca(item) {
    if (parseFloat(item.cantidadM) > parseFloat(item.cantidad)) {
      return 0
    } else {
      let cant = parseFloat(item.cantidadM) - parseFloat(item.cantidad)
      if (cant < 0) cant = cant * -1
      return (cant).toFixed(0)
    }
  }

  calcularFaltanteArt(item) {
    if (parseFloat(item.renglones) > parseFloat(item.proyeccionP)) {
      return 0
    } else {
      return (parseFloat(item.proyeccionP) - parseFloat(item.renglones)).toFixed(0)
    }
  }

  calcularFaltanteCli(item) {
    if (parseFloat(item.clientes) > parseFloat(item.proyeccionC)) {
      return 0
    } else {
      return (parseFloat(item.proyeccionC) - parseFloat(item.clientes)).toFixed(0)
    }
  }

  validarPor(item) {
    return item > 100 ? 100 : item
  }

  initialize(){
    if(window.localStorage.getItem('network') === '1'){
      this.loadCli = (this.loadFact = (this.loadPed = true) )
      this.loadAct = false
      this.http.get(this.super ? `pedidosCom/contadores?vendedores=${window.localStorage.getItem('vendedores')}` : `pedidosCom/contadores?ven=${this.co_ven}`).subscribe(
        (res:any=[])=>{
          if (res && res[0]) {
            this.pedidos = res[0]
            this.pedidos_cre = res[0].creados
            this.pedidos_anu = res[0].anulados
            this.pedidos_pro = res[0].procesados
            window.localStorage.setItem('creados', JSON.stringify(this.pedidos_cre))
            window.localStorage.setItem('anulados', JSON.stringify(this.pedidos_anu))
            window.localStorage.setItem('proces', JSON.stringify(this.pedidos_pro))
          } else {
            this.pedidos = 
            this.pedidos_cre = 0
            this.pedidos_anu = 0
            this.pedidos_pro = 0
            window.localStorage.setItem('creados', JSON.stringify(this.pedidos_cre))
            window.localStorage.setItem('anulados', JSON.stringify(this.pedidos_anu))
            window.localStorage.setItem('proces', JSON.stringify(this.pedidos_pro))
          }
          this.loadPed = false
        },
        error=>{
          console.log(error)
          this.loadPed = false
        }
      )
      this.http.get(this.super ? `factura/dashboard?vendedores=${window.localStorage.getItem('vendedores')}` : `factura/dashboard?ven=${this.co_ven}`).subscribe(
        (res:any=[])=>{
          this.facturas = res[0].facturas
          this.monto = res[0].deuda
          window.localStorage.setItem('facturas',this.facturas)
          window.localStorage.setItem('monto',this.monto)
          this.loadFact = false
        },
        error=>{
          console.log(error)
          this.loadFact = false
        }
      )
      this.http.get(this.super ? `cliente/dashboard?vendedores=${window.localStorage.getItem('vendedores')}` : `cliente/dashboard?ven=${this.co_ven}`).subscribe(
        (res:any=[])=>{
          this.loadCli = false
          this.solventes = res[0].solventes
          this.morosos = res[0].deudores
          this.cuentas = res[0].cobrar
          window.localStorage.setItem('solventes',this.solventes)
          window.localStorage.setItem('morosos',this.morosos)
          window.localStorage.setItem('cuentas',this.cuentas)
        },
        error=>{
          console.log(error)
          this.loadCli = false
        }
      )
      this.http.get(this.super ? `activacion/dashboard?vendedores=${window.localStorage.getItem('vendedores')}` : `activacion/dashboard?ven=${this.co_ven}`).subscribe(
        (res:any=[])=>{
          this.loadAct = false
          this.activacion = res[0].activacion
          this.noactivacion = res[0].noactivacion
          window.localStorage.setItem('activacion',this.activacion)
          window.localStorage.setItem('noactivacion',this.noactivacion)
        },
        error=>{
          console.log(error)
          this.loadAct = false
        }
      )
      if (!this.super) {
        this.http.get("vendedor/proyecciones?ven=" + this.co_ven).subscribe((res:any) =>{
          this.proyeccion = res[0]
        }, err=>{
          console.log(err)
        })
      } else {
        this.http.get("vendedor/proyeccionesAdmin2?vendedores=" + window.localStorage.getItem('vendedores')).subscribe((res:any) =>{
          this.proyeccion = res
        }, err=>{
          console.log(err)
        })
      }
      this.http.get('respaldoFechas').subscribe((res:any) => {
        if (res && res.length > 0) {
          this.fechaA = moment(res[0].tasas).format('DD-MM-YYYY H:mm A')
        }
      })
      this.http.get('tasas/moneda').subscribe((res:any) => {
        if (res && res.length > 0) this.tasa = res[0].tasa_v
      })
    }else{
      this.pedidos_cre = JSON.parse(window.localStorage.getItem('creados'))
      this.pedidos_anu = JSON.parse(window.localStorage.getItem('anulados'))
      this.pedidos_pro = JSON.parse(window.localStorage.getItem('proces'))
      this.facturas = (window.localStorage.getItem('facturas'))
      this.monto = (window.localStorage.getItem('monto'))
      this.activacion = (window.localStorage.getItem('activacion'))
      this.noactivacion = (window.localStorage.getItem('noactivacion'))
      this.solventes = (window.localStorage.getItem('solventes'))
      this.solventes = (window.localStorage.getItem('solventes'))
      this.morosos = (window.localStorage.getItem('morosos'))
      this.cuentas = (window.localStorage.getItem('cuentas'))
    }
  }

  irCarrito(){
    if (this.pedido && this.pedido.articulos && this.pedido.articulos.length > 0) {
      let cliente = this.pedido.cliente
      this.navCtrl.push(HomePage, {pedido:true, cliente})
      // this.navCtrl.push(PedidoPage)
    } else {
      this.toastCtrl.create({
        duration: 4000,
        message:'El carrito se encuentra vacío.'
      }).present()
    }
  }

  goToPage(page,filter){
    switch(page){
      case 'pedidos':
        this.navCtrl.push(PedidosPage, { filter })
        break;
      case 'clientes':
        this.navCtrl.push(ClientesPage, { filter })
        break;
      case 'cuentas':
        this.navCtrl.push(FacturasPage)
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts